'use strict';

export default function($stateProvider) {
    'ngInject';
    $stateProvider
        .state('ad-aggregation', {
            url: '/ad-aggregation',
            template: '<ad-aggregation></ad-aggregation>'
        });
}



// WEBPACK FOOTER //
// ./client/app/ad-aggregation/ad-aggregation.routes.js